import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { ImageUrls } from "src/app/services/s3buket";
import { apiUrl } from "../../global/global";

@Component({
  selector: "app-edit-profile",
  templateUrl: "./edit-profile.component.html",
  styleUrls: ["./edit-profile.component.css"]
})
export class EditProfileComponent implements OnInit {
  userData;
  profileImage;
  allData:any;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  constructor(public route: ActivatedRoute, private router: Router,private api: AdminService,) { }

  ngOnInit(): void {
    this.userData = localStorage.getItem("userId")
    this.getUserDetail();
  }
  //getUserDetail
  getUserDetail(){
    this.api.getDatas(apiUrl._getRecuriterDetail+"/"+this.userData)
    .subscribe(async (res) => {
      console.log(res,"stats");
      this.allData = res.data.Recruiter;
      this.profileImage = this.globalUrl + res.data.Recruiter?.profileImage; 
    })
  }
}
